import React from 'react';
import { SubpageBanner, Cta1 } from '../components';
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
    const { t } = useTranslation();

    return (
        <div>
            <SubpageBanner
                title={t('aboutUs.bannerTitle')}
                page={t('aboutUs.bannerPage')}
                text={t('aboutUs.bannerText')}
                path="/about-us"
            />
            <div className="about-us-page">
                {/* Tanıtım Metni */}
                <div className="about-intro-section">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-lg-6 about-intro-col-left">
                                <p className="about-intro-text">{t('aboutUs.intro.p1')}</p>
                                <p className="about-intro-text">{t('aboutUs.intro.p2')}</p>
                            </div>
                            <div className="col-lg-6 about-intro-col-right">
                                <p className="about-intro-text">{t('aboutUs.intro.p3')}</p>
                                <p className="about-intro-text">{t('aboutUs.intro.p4')}</p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Vizyon & Misyon Bölümü */}
                <div className="about-vm-section">
                    {/* Vizyon: Sol metin, sağ görsel */}
                    <div className="container">
                        <div className="about-vm-row">
                            <div className="about-vm-content">
                                <span className="about-vm-badge">{t('aboutUs.vision.badge')}</span>
                                <h2 className="about-vm-title">{t('aboutUs.vision.title')}</h2>
                                <p className="about-vm-text">{t('aboutUs.vision.desc')}</p>
                            </div>
                            <div className="about-vm-image">
                                <img src="/assets/images/new-img/vizyon.png" alt="Vizyon" />
                            </div>
                        </div>
                    </div>

                    {/* Misyon: Sol görsel, sağ metin */}
                    <div className="container">
                        <div className="about-vm-row reverse mb-5">
                            <div className="about-vm-content">
                                <span className="about-vm-badge">{t('aboutUs.mission.badge')}</span>
                                <h2 className="about-vm-title">{t('aboutUs.mission.title')}</h2>
                                <p className="about-vm-text">{t('aboutUs.mission.desc')}</p>
                            </div>
                            <div className="about-vm-image">
                                <img src="/assets/images/new-img/misyon.png" alt="Misyon" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Partner & Piyasa Yapıcı - Yan Yana */}
                <div className="about-programs-section">
                    <div className="container">
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="about-program-card">
                                    <h3 className="about-program-title">{t('aboutUs.pillars.partner.title')}</h3>
                                    <p className="about-program-text">{t('aboutUs.pillars.partner.desc')}</p>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="about-program-card">
                                    <h3 className="about-program-title">{t('aboutUs.pillars.marketMaker.title')}</h3>
                                    <p className="about-program-text">{t('aboutUs.pillars.marketMaker.desc')}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Yönetim Kadrosu */}
                <div className="about-management-section">
                    <div className="container">
                        <h2 className="about-section-title">{t('aboutUs.management.title')}</h2>
                        <p className="about-section-desc">{t('aboutUs.management.desc')}</p>
                        <div className="row g-4 mt-4">
                            {t('aboutUs.management.team', { returnObjects: true }).map((member, index) => (
                                <div key={index} className="col-lg-6">
                                    <div className="about-member-card">
                                        <h4 className="about-member-name">{member.name}</h4>
                                        <p className="about-member-title">{member.title}</p>
                                        <p className="about-member-desc">{member.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                {/* Global Yapılanma */}
                <div className="about-global-section">
                    <div className="container">
                        <h2 className="about-section-title">{t('aboutUs.global.title')}</h2>
                        <p className="about-section-desc mb-3">{t('aboutUs.global.desc')}</p>
                        <ul className="about-global-list">
                            {t('aboutUs.global.items', { returnObjects: true }).map((item, index) => (
                                <li key={index}>{item}</li>
                            ))}
                        </ul>
                        {t('aboutUs.global.footer') && (
                            <p className="about-section-footer">{t('aboutUs.global.footer')}</p>
                        )}
                    </div>
                </div>

                <Cta1
                    title={<><span style={{color: '#31cce5' }}>{t('home.ctaInvestment')}</span> {t('home.ctaTitle')}</>}
                subtitle={<span>{t('home.ctaSubtitle')}</span>}
                />
            </div>
        </div>
    );
};

export default AboutUs;
